import React from 'react';
import { Box, CheckIcon, CrossIcon, Inscription, Preloader } from '@common-fe/common-fe';

interface Props {
  title: string;
  isSuccess: boolean;
  isLoading: boolean;
  testId: string;
}

const CheckingWrapper: React.FC<Props> = ({ title, isSuccess, testId, isLoading }) => (
  <Box
    data-testId={`CheckingWrapper_${testId}`}
    direction="row"
    align="center"
  >
    <Box width="24px" height="24px" align="center" justify="center" margin={{ right: 'spacing4' }}>
      {isLoading ? <Preloader size={12} thinSize={3} /> : isSuccess
          ? <CheckIcon size="19px" color="success" />
          : <CrossIcon size="19px" color="danger" />}
    </Box>
    <Inscription margin={{ left: 'spacing4' }} lineHeight="20px">
      {title}
    </Inscription>
  </Box>
);

export default CheckingWrapper;
